export default {
  IDLE: 'IDLE',
  INIT: 'INIT',
  LOADING: 'LOADING',
  FINAL: 'FINAL',

  PRE_SPIN_START: 'PRE_SPIN_START',
  SPIN_START: 'SPIN_START',
  SPIN_STOP: 'SPIN_STOP',

  REQUEST_SPIN: 'REQUEST_SPIN',
  GET_SPIN_RESPONSE: 'GET_SPIN_RESPONSE',
  GET_BUY_FREESPIN_RESPONSE: 'GET_BUY_FREESPIN_RESPONSE',

  SHOW_WINNINGS: 'SHOW_WINNINGS',
  SHOW_BIGWIN: 'SHOW_BIGWIN',
  START_COUNTUP_WINNINGS: 'START_COUNTUP_WINNINGS',
  SHOW_CYCLEWINNINGS: 'SHOW_CYCLEWINNINGS',
  SHOW_SCATTERS: 'SHOW_SCATTERS',

  INTRO_BONUS: 'INTRO_BONUS',
  BONUS_GAME: 'BONUS_GAME',
  OUTRO_BONUS: 'OUTRO_BONUS',
  BONUS_WIN_ADD: 'BONUS_WIN_ADD',
  FREE_SPINS_INTRO: 'FREE_SPINS_INTRO',
  FREE_SPINS_BUY: 'FREE_SPINS_BUY',
  OUTRO_FREESPINS: 'OUTRO_FREESPINS'
}
